var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu-template-container" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: { "tab-remove": _vm.handleTabRemove },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        _vm._l(_vm.panes, function (pane) {
          return _c(
            "el-tab-pane",
            {
              key: pane.name,
              attrs: {
                label: pane.label,
                name: pane.name,
                closable: ![
                  "commonManage",
                  "timeManage",
                  "groupDinnerManage",
                ].includes(pane.name),
              },
            },
            [
              pane.name === "commonManage"
                ? [
                    _vm.activeTab === "commonManage"
                      ? _c("commonMenuTemplateManage", {
                          key: "common-" + _vm.activeTab,
                          ref: "commonMenuTemplateManage",
                          refInFor: true,
                          on: {
                            "edit-template": _vm.handleEditTemplate,
                            "group-sort": _vm.handleGroupSort,
                          },
                        })
                      : _vm._e(),
                  ]
                : pane.name === "timeManage"
                ? [
                    _vm.activeTab === "timeManage"
                      ? _c("timeMenuTemplateManage", {
                          key: "time-" + _vm.activeTab,
                          ref: "timeMenuTemplateManage",
                          refInFor: true,
                          on: { "edit-template": _vm.handleEditTemplate },
                        })
                      : _vm._e(),
                  ]
                : pane.name === "groupDinnerManage"
                ? [
                    _vm.activeTab === "groupDinnerManage"
                      ? _c("groupDinnerTemplateManage", {
                          key: "groupDinner-" + _vm.activeTab,
                          ref: "groupDinnerTemplateManage",
                          refInFor: true,
                          on: { "edit-template": _vm.handleEditTemplate },
                        })
                      : _vm._e(),
                  ]
                : pane.type === "groupSort"
                ? [
                    _vm.activeTab === pane.name
                      ? _c("group-sort", {
                          key: "groupSort-" + pane.templateId,
                          ref: "groupSort_" + pane.templateId,
                          refInFor: true,
                          attrs: {
                            templateId: pane.templateId,
                            templateName: pane.templateName,
                          },
                        })
                      : _vm._e(),
                  ]
                : [
                    _c("detail", {
                      ref: "templateDetail_" + pane.templateId,
                      refInFor: true,
                      attrs: { templateId: pane.templateId },
                    }),
                  ],
            ],
            2
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }